import { LightstepConfig } from '@domgen/dgx-fe-lightstep';
import { AppConfig } from '../../models/config/app-config.type';

export const lightstepConfigFactory = (config: AppConfig): LightstepConfig =>
  config.lightstep;
